import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchEStoreOrderList = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/eStoreOrder/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            commit('setEStoreOrderList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number, total_amount: res.data.total_amount})
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchEStoreOrderData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/eStoreOrder/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('setEStoreOrderData', res.data.response)   
        } else {
            commit('resetEStoreOrderData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitEStoreOrderData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/eStoreOrder/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteEStoreOrderData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/eStoreOrder/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            dispatch('fetchEStoreOrderList', payload.list)            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreOrder/actions.js